import { Controller, useFormContext } from 'react-hook-form'

import { usAndTerritories } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { updateStateField } from '../../../../../helpers'

export const Country = () => {
  const { control, setValue, clearErrors, getValues } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.country"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="86. Country"
          field={field}
          input={(props) => (
            <Select
              {...props}
              onChange={(value) => {
                updateStateField('institutionContactInfo.state', value, setValue, getValues, clearErrors)
                field.onChange(value)
              }}
              data={usAndTerritories}
              data-qa="86. Country"
              options-data-qa="86. Country option"
            />
          )}
        />
      )}
    />
  )
}
